export default __webpack_public_path__ + "static/tj-2deed90ce74f9c34a9245dcddbfe3311.svg";